import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import YearGroupSelector from "./routes/YearGroupSelector";
import Manage from "./routes/Manage";
import VerticalInsights from "./routes/VerticalInsights";
import GenericInsightsView from "./routes/GenericInsightsView";

export default store => ({
  path: "curriculum-insights",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-insights" */ "./components"),
      import("./modules/CurriculumInsightsModule"),
      import(
        /* webpackChunkName: "curriculum-insights" */ "ToddleAnalytics/modules/ToddleAnalyticsModule"
      ),
    ]).then(([importedModule0, importedModule1, importedModule2]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const toddleAnalyticsReducer = importedModule2.default;

      injectReducer(store, {
        key: "curriculumInsights",
        reducer,
      });

      // The AI playground reads `state.toddleAnalytics.*`. Inject it here so
      // the playground works even if the user has never visited toddle-insights.
      // injectReducer is keyed; if toddle-insights already injected it, this is a no-op.
      injectReducer(store, {
        key: "toddleAnalytics",
        reducer: toddleAnalyticsReducer,
      });

      return component;
    })
  ),
  childRoutes: [
    YearGroupSelector(store),
    Manage(store),
    VerticalInsights(store),
    GenericInsightsView(store),
  ],
});
